import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import React from "react";
import About from "./About.js";

export default function Placeholder() {
  return (
    <Router>
      <Switch>
        <Route path="/about">
          <About />
        </Route>
      </Switch>
    </Router>
  );
}
